export default __webpack_public_path__ + "static/media/user.8ea392a6.jpeg";